import "../../css/pages/aboutUs.scss";
import { inView } from "../modules/inView";
import accordion from "../modules/accordion";
import titleRobotoFlex from "../modules/titleRobotoFlex";
import anchorSets from "../modules/anchorSets";

import BasePage from "./base";

class AboutUsPage extends BasePage {
    constructor(...opts) {
        super(...opts);
        this.textAndImages = document.querySelectorAll(".textAndImage");
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        accordion.init();
        anchorSets.init();
        const self = this;
        window.addEventListener("scroll", function() {
            self.onScroll();
        });
        titleRobotoFlex.init();
    }

    onScroll() {
        this.textAndImages.forEach(elem => {
            const textContainer = elem.querySelector(".textAndImage__textContainer");
            const textContents = elem.querySelector(".textAndImage__textContents");
            const anchor = elem.querySelector(".slideIn__anchor");
            if (inView(anchor)) {
                textContainer.classList.remove("slideIn");
                setTimeout(function() {
                    textContents.classList.remove("slideIn");
                }, 500);
            }
        });
    }
}

new AboutUsPage();
